const NBSP = 160;
const SPACE = 32;

const NBSP_CHAR = String.fromCharCode(NBSP);
const SPACE_CHAR = String.fromCharCode(SPACE);

const spaceGroups = /\s+/g;
const spaces = /\s/g;

function nonBreakingSpaceGroup(match: any, offset: number, str: string) {
  // A leading or trailing space group should be all NBSPs
  if (offset === 0 || offset + match.length === str.length) {
    return match.replace(spaces, NBSP_CHAR);
  }
  // if the group has 1 space it can break
  if (match.length === 1) {
    return SPACE_CHAR;
  }
  // two spaces becomes one breaking and one non-breaking
  if (match.length === 2) {
    return SPACE_CHAR + NBSP_CHAR;
  }
  // greater than two spaces becomes non-breaking with breaking
  // at the beginning and the end
  let result = SPACE_CHAR;
  for (let i = 1; i < match.length - 1; i++) {
    result += NBSP_CHAR;
  }
  return result + SPACE_CHAR;
}

export function toBreakingString(str: string) {
  return str.replace(spaces, SPACE_CHAR);
}

export function toCharArray(str: string) {
  const chars = [];
  for (let i = 0; i < str.length; i++) {
    chars.push(str.charCodeAt(i));
  }
  return chars;
}

export function toNonBreakingString(str: string) {
  return str.replace(spaceGroups, nonBreakingSpaceGroup);
}

export function isUnfancy(str: string) {
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 128) return false;
  }
  return true;
}

export function inputCouldMatch(input: string, match: string) {
  // If the next match text char is in the "unfancy" range, it might require multiple keystrokes to
  // type (e.g. "¨" + "u" = "ü"). See #3885
  let matchedSubstring = '';
  for (let i = 0; i < match.length; i++) {
    if (match[i] !== input[i]) break;
    matchedSubstring += input[i];
  }
  const mismatchedInput = input.slice(matchedSubstring.length);
  if (
    mismatchedInput.length > 0 &&
    isUnfancy(match.charAt(matchedSubstring.length))
  ) {
    return false;
  }
  return true;
}
